export const DraftQueueRoutes: Readonly<{
  PageIndex: 'draft-queue';
  List: 'list';
}> = {
  PageIndex: 'draft-queue',
  List: 'list',
};
